

























































import {Component, Mixins} from 'vue-property-decorator';
import TabBar from '@/components/lib/TabBar.vue';
import IconCustom from '@/components/lib/IconCustom.vue';
import ButtonCommon from '@/components/lib/ButtonCommon.vue';
import TravelPreviewCard from '@/components/cards/TravelPreviewCard.vue';
import PlaceholderCard from '@/components/cards/PlaceholderCard.vue';
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin';
import {updateItems} from '@/lib';
import {IOption} from '@/components/lib/models';
import {ITravelByCategory, ITravel} from '@/entities';
import { TravelFormat, TravelFormatArray } from '../entities/abstract/travelFormat.model';

@Component({
  components: {
    TabBar,
    IconCustom,
    ButtonCommon,
    TravelPreviewCard,
    PlaceholderCard
  }
})
export default class TravelsPreviewSection extends Mixins(onLocaleChangeMixin) {

  protected initFetches = [
    this.initTravels
  ];

  protected reFetches = [
    this.updateTravels
  ];

  protected fetching: boolean = false;

  // get categories(): Category[] {
  //   return CategoryArray.map((item: Category) => item);
  // }

  get travelFormats(): TravelFormat[] {
    return TravelFormatArray.map(item => item);
  }

  private current: TravelFormat = this.travelFormats[0];
  private travelsLimit: number = 4;

  get choice(): TravelFormat {
    return this.current;
  }
  set choice(travelFormat: TravelFormat) {
    this.current = travelFormat;
    this.fetchCurrentTravels();
  }

  get linkLabel(): string {
    return (
      this.travelsToShow.length ?
        this.$t('home.more-travels') :
        this.$t('home.all-travels')
    ) as string
  }

  get mayHaveItems(): boolean {
    return !!this.travelsToShow.length || this.fetching;
  }

  private initTravels(): void {
    this.travelsByCategory = this.travelFormats.map((travelFormat: TravelFormat) => ({
      travelFormat: travelFormat,
      travels: undefined
    }));
    this.fetchCurrentTravels();
  }

  private updateTravels(): void {
    this.travelsByCategory.forEach((el: ITravelByCategory) => {
      updateItems<ITravel>(el.travels, this.$storage.actions.getTravelById);
    });
  }

  private fetchCurrentTravels(): void {
    let byTravelFormat = this.travelsByCategory
      .find((el: ITravelByCategory) => el.travelFormat === this.current);
    if (byTravelFormat && byTravelFormat.travels === undefined) {
      this.fetching = true;
      this.$storage.actions.fetchTravels({
        payload: {
          travel_format: [
            this.current
          ],
          page_size: this.travelsLimit,
          ordering: '-date_creation'
        }
      })
        .then(res => {
          if (byTravelFormat) {
            byTravelFormat.travels = res.results || [];
          }
        })
        .catch(() => {
          if (byTravelFormat) byTravelFormat.travels = [];
        })
        .finally(() => {
          this.fetching = false;
        });
    }
  }

  private travelsByCategory: ITravelByCategory[] = [];

  get currentTravels(): ITravel[] {
    let travelsByCurrentCategory = this.travelsByCategory
      .find((el: ITravelByCategory) => el.travelFormat === this.current);
    return travelsByCurrentCategory?.travels || [];
  }

  get travelsToShow(): ITravel[] {
    return this.validTravels.slice(0, this.travelsLimit);
  }

  get validTravels(): ITravel[] {
    return this.currentTravels.filter((travel: ITravel) => travel.validate());
  }

  get travelFormatOptions(): IOption<TravelFormat>[] {
    return this.travelFormats.map((travelFormat: TravelFormat) => ({
      // name: travelFormat.toUpperCase() + ' ' + this.$t(`travelFormats.${travelFormat}.name`),
      name: '' + ' ' + this.$t(`travelFormats.${travelFormat}.name`),
      value: travelFormat
    }));
  }

  get travelFormatDescription(): string {
    return this.$t('travelFormats.' + this.current + '.description') as string;
  }

}
